<script>
    import { createEventDispatcher } from 'svelte';

    const dispatcher = createEventDispatcher();
    let buyInPanel;
    let buyInInput;
    let autoReBuy;
    let autoTopOff;
    export let minBuyIn;
    export let maxBuyIn;

    export function show()
    {
        buyInPanel.style.display = "block";
    }

    function onGiftSelected()
    {
        buyInPanel.style.display = "none";
        dispatcher('giftSelected', {gift: "coffee", price: 15, receipt: ""});
    }

    function onCancel()
    {
        buyInPanel.style.display = "none";
    }

</script>

<ion-card class="panel" bind:this={buyInPanel} style="display: none;">
    <ion-card-header style="text-align: center;">
      <ion-card-title>Select Gift</ion-card-title>
    </ion-card-header>
  
    <ion-card-content style="text-align: center;">
        <ion-item>
            <div class="center" style="width: 100%;">
            <img src={"/assets/coffee.png"} alt="Coffee" />
            15
            </div>
        </ion-item>
        <div class="hbox center" style="padding-top: 15px;">
            <ion-button on:click={onGiftSelected}>Buy Gift</ion-button>
            <ion-button on:click={onCancel}>Cancel</ion-button>
        </div>
    </ion-card-content>
</ion-card>

<style>
    .panel {
        position: absolute;
        width: 280px;
        height: 180px;
        left: 260px;
        top: 190px;
    }
</style>